<ul class="autoInfo">
  <li>
    <app-ds-icon
      [icon]="icon.PersonOutline"
      [color]="iconColor"
      [size]="20">
    </app-ds-icon>
    <app-ds-typography
      [text]="passengers"
      [size]="fontSize"
      [color]="fontColor">
    </app-ds-typography>
  </li>
  <li *ngIf="hasBaggage">
    <app-ds-icon
      [icon]="icon.WorkOutline"
      [color]="iconColor"
      [size]="20">
    </app-ds-icon>
    <app-ds-typography
      [text]="baggage"
      [size]="fontSize"
      [color]="fontColor">
    </app-ds-typography>
  </li>
  <li>
    <app-ds-icon
      [icon]="icon.Freeze"
      [color]="iconColor"
      [size]="20">
    </app-ds-icon>
    <app-ds-typography
      [text]="airConditioned | transloco"
      [size]="fontSize"
      [color]="fontColor">
    </app-ds-typography>
  </li>
  <li>
    <app-ds-icon
      [icon]="icon.CarDoor"
      [color]="iconColor"
      [size]="20">
    </app-ds-icon>
    <app-ds-typography
      [text]="doors"
      [size]="fontSize"
      [color]="fontColor">
    </app-ds-typography>
  </li>
  <li>
    <app-ds-icon
      [icon]="icon.CarChange"
      [color]="iconColor"
      [size]="20">
    </app-ds-icon>
    <app-ds-typography
      [text]="transmission | transloco"
      [size]="fontSize"
      [color]="fontColor">
    </app-ds-typography>
  </li>
</ul>
